import React from 'react';
import {
  Accordion,
  AccordionSummary,
  NativeSelect,
  AccordionDetails,
  Typography,
  Grid,
  Button,
  Paper,
  Input,
  TextField
} from '@material-ui/core';
import CurrencyTextField from '@unicef/material-ui-currency-textfield';
import InputMask from 'react-input-mask';
import { useDispatch } from 'react-redux';
import { CreatorsAnchors } from '../../../../store/ducks/anchors';

import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import Header from '../../../../layout/Header';
import Subheader from '../../../../layout/Subheader';
import Loading from '../../../../components/Loading';
import PhoneMask from '../../../Collaborator/components/PhoneMask'

import useStyles from './style';

import GridAncorasContatos from '../components/GridAncorasContatos';
import GridAncorasLojas from '../components/GridAncorasLojas';
import GridAncorasTaxasFaixas from '../components/GridAncorasTaxasFaixas';
import GridAncorasImportacoesTitulos from '../components/GridAncorasImportacoesTitulos';

import { formatDateTimeToRender, formatDateToRender, capitalizeFirstLetter } from '../../../../utils/functions';

function Render({
  ancoraId,
  inputs,
  handleInputChange,
  handleFileChange,
  getLoading,
  onSubmit,
  findAllAncorasContatos,
  getAncorasContatos,
  getAncorasLoadingContatos,
  ancorasContatosRef,
  ancorasTaxasFaixasRef,
  ancorasLojasRef,
  findAllAncorasLojas,
  getAncorasLojas,
  getAncorasLoadingLojas,
  findAllAncorasTaxasFaixas,
  getAncorasTaxasFaixas,
  getAncorasLoadingTaxasFaixas,
  getErros,
  setErros,
  findCep,
  inputsBlocked,
  getEstados,
  getMunicipios,
  getLayoutsEmailsInteresses,
  getLayoutsEmailsAncoras,
  getLayoutsEmailsAntecipacoes,
  getLayoutsEmailsAntecipacoesAprovadas,
  getLayoutsEmailsAntecipacoesReprovadas,
  getLayoutsEmailsAntecipacoesVencidas,
  getLayoutsArquivoTitulosImportação,
  getLayoutsArquivoTituloExportação,
  getLayoutsEmailsFechamentosMeses,
  lastGrid,
  destinoOpcoes,
  handleInputNumberChange
}) {
  const classes = useStyles();
  const dispatch = useDispatch();

  const [getLogoLoaded, setLogoLoaded] = React.useState();
  const [getAssinaturaLoaded, setAssinaturaLoaded] = React.useState();

  const handleTimeValues = (event, value) => {
    let valueFormated = value.replace(/[^0-9]/g, "");
    let horaTime = valueFormated.slice(0, 2);
    let minutosTime = valueFormated.substr(2);

    if (minutosTime.length == 1) {
      minutosTime = Number(minutosTime) + '0'
    }

    if (minutosTime == '' && Number(horaTime) < 10) {
      horaTime = Number(horaTime) + '0'
    } else if (Number(horaTime) > 23) {
      horaTime = '23'
    } else if (Number(horaTime) < 10) {
      horaTime = '0' + Number(horaTime)
    } else if (horaTime == '') {
      horaTime = '00'
    }

    if (Number(minutosTime) > 59) {
      minutosTime = '59'
    } else if (Number(minutosTime) < 10) {
      minutosTime = '0' + Number(minutosTime)
    } else if (minutosTime == '') {
      minutosTime = '00'
    }

    valueFormated = horaTime + ':' + minutosTime
    handleInputChange(event, valueFormated);
  };


  return (
    <div className={classes.root}>
      <Header />
      <Subheader
        title="Editando Rede: "
        back="/app/ancoras"
        loading={getLoading}
        submit={onSubmit}
        submitText="Atualizar"
        subanchor={true}
      />
      <div className={classes.content}>
        <div className={classes.rootForm} style={{ marginLeft: '5%', width: '90%' }}>
          {getLoading ? (
            <Loading />
          ) : (
            <div>
              <form onSubmit={onSubmit}>
                <Accordion defaultExpanded>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                    className={classes.summary}
                  >
                    <Typography className={classes.heading}>Informações</Typography>
                  </AccordionSummary>
                  <AccordionDetails className={classes.details}>
                    <Grid container>
                      <Grid Item xs={1}>
                        <label className={classes.label}>Id</label>
                        <Paper className={classes.medium} elevation={0}>
                          <Input
                            className={classes.inputId}
                            classes={{ input: classes.inputId }}
                            placeholder="AncoraId"
                            value={inputs.ancoraId}
                            name="ancoraId"
                            disabled={true}
                            onBlur={(event) =>
                              getErros.includes('AncoraId') &&
                              setErros(
                                getErros.filter(function (item) {
                                  return item !== 'AncoraId';
                                }),
                              )
                            }
                            error={getErros.includes('AncoraId')}
                            onChange={handleInputChange}
                            autoComplete="off"
                            inputProps={{
                              maxLength: 6,
                            }}
                          />
                        </Paper>
                      </Grid>
                      <Grid item xs={5}>
                        <label className={classes.label}>Cnpj</label>
                        <Paper className={classes.medium} elevation={0}>
                          <InputMask
                            mask="99.999.999/9999-99"
                            value={inputs.cnpj}
                            name="cnpj"
                            onBlur={(event) =>
                              getErros.includes('Cnpj') &&
                              setErros(
                                getErros.filter(function (item) {
                                  return item !== 'Cnpj';
                                }),
                              )
                            }
                            disabled={false}
                            onChange={handleInputChange}
                            autocomplete="off"
                          >
                            {() => (
                              <Input
                                className={classes.input}
                                placeholder="CNPJ"
                                name="cnpj"
                                error={getErros.includes('Cnpj')}
                              />
                            )}
                          </InputMask>
                        </Paper>
                      </Grid>
                      <Grid item xs={6}>
                        <label className={classes.label}>Status</label>
                        <Paper className={classes.medium} elevation={0}>
                          <NativeSelect
                            className={classes.input}
                            value={inputs.status}
                            name="status"
                            onChange={handleInputChange}
                            error={getErros.includes('Status')}
                            onBlur={(event) =>
                              getErros.includes('Status') &&
                              setErros(
                                getErros.filter(function (item) {
                                  return item !== 'Status';
                                }),
                              )
                            }
                          >
                            <option value="Ativo">Ativo</option>
                            <option value="Inativo">Inativo</option>
                            <option value="Pendente">Pendente</option>
                          </NativeSelect>
                        </Paper>
                      </Grid>
                      <Grid item xs={6}>
                        <label className={classes.label}>Razão Social</label>
                        <Paper className={classes.medium} elevation={0}>
                          <Input
                            style={{ textTransform: 'uppercase !important' }}
                            className={classes.input}
                            classes={{ input: classes.inputText }}
                            placeholder="Razão Social"
                            value={inputs.razaoSocial}
                            name="razaoSocial"
                            onBlur={(event) =>
                              getErros.includes('RazaoSocial') &&
                              setErros(
                                getErros.filter(function (item) {
                                  return item !== 'RazaoSocial';
                                }),
                              )
                            }
                            error={getErros.includes('RazaoSocial')}
                            onChange={handleInputChange}
                            autoComplete="off"
                            inputProps={{
                              maxLength: 100,
                            }}
                          />
                        </Paper>
                      </Grid>
                      <Grid item xs={6}>
                        <label className={classes.label}>Nome Fantasia</label>
                        <Paper className={classes.medium} elevation={0}>
                          <Input
                            style={{ textTransform: 'uppercase !important' }}
                            className={classes.input}
                            classes={{ input: classes.inputText }}
                            placeholder="Nome Fantasia"
                            value={inputs.nomeFantasia}
                            name="nomeFantasia"
                            onBlur={(event) =>
                              getErros.includes('NomeFantasia') &&
                              setErros(
                                getErros.filter(function (item) {
                                  return item !== 'NomeFantasia';
                                }),
                              )
                            }
                            error={getErros.includes('NomeFantasia')}
                            onChange={handleInputChange}
                            autoComplete="off"
                            inputProps={{
                              minLength: 3,
                              maxLength: 100,
                            }}
                          />
                        </Paper>
                      </Grid>
                      <Grid item xs={6}>
                        <label className={classes.label}>Apelido Rede</label>
                        <Paper className={classes.medium} elevation={0}>
                          <Input
                            style={{ textTransform: 'uppercase !important' }}
                            className={classes.input}
                            classes={{ input: classes.inputText }}
                            placeholder="Apelido"
                            value={inputs.apelido}
                            name="apelido"
                            onBlur={(event) =>
                              getErros.includes('apelido') &&
                              setErros(
                                getErros.filter(function (item) {
                                  return item !== 'apelido';
                                }),
                              )
                            }
                            error={getErros.includes('apelido')}
                            onChange={handleInputChange}
                            autoComplete="off"
                            inputProps={{
                              maxLength: 100,
                            }}
                          />
                        </Paper>
                      </Grid>
                      <Grid item xs={6}>
                        <label className={classes.label}>ERP</label>
                        <Paper className={classes.medium} elevation={0}>
                          <Input
                            style={{ textTransform: 'uppercase !important' }}
                            className={classes.input}
                            classes={{ input: classes.inputText }}
                            placeholder="Erp"
                            value={inputs.erp}
                            name="erp"
                            onBlur={(event) =>
                              getErros.includes('Erp') &&
                              setErros(
                                getErros.filter(function (item) {
                                  return item !== 'Erp';
                                }),
                              )
                            }
                            error={getErros.includes('Erp')}
                            onChange={handleInputChange}
                            autoComplete="off"
                            inputProps={{
                              minLength: 3,
                              maxLength: 100,
                            }}
                          />
                        </Paper>
                      </Grid>
                      <Grid Item xs={6}>
                        <label className={classes.label}>Departamento Antecipação</label>
                        <Paper className={classes.medium} elevation={0}>
                          <Input
                            style={{ textTransform: 'uppercase !important' }}
                            className={classes.input}
                            classes={{ input: classes.inputText }}
                            placeholder="Departamento Antecipação"
                            value={inputs.departamentoAntecipacao}
                            name="departamentoAntecipacao"
                            onBlur={(event) =>
                              getErros.includes('DepartamentoAntecipacao') &&
                              setErros(
                                getErros.filter(function (item) {
                                  return item !== 'DepartamentoAntecipacao';
                                }),
                              )
                            }
                            error={getErros.includes('DepartamentoAntecipacao')}
                            onChange={handleInputChange}
                            autoComplete="off"
                            inputProps={{
                              maxLength: 100,
                            }}
                          />
                        </Paper>
                      </Grid>
                      <Grid item xs={6}>
                        <label className={classes.label}>Link Domínio Externo</label>
                        <Paper className={classes.medium} elevation={0}>
                          <Input
                            className={classes.input}
                            placeholder="Link Domínio Externo"
                            value={inputs.linkDominioExterno}
                            name="linkDominioExterno"
                            onBlur={(event) =>
                              getErros.includes('LinkDominioExterno') &&
                              setErros(
                                getErros.filter(function (item) {
                                  return item !== 'LinkDominioExterno';
                                }),
                              )
                            }
                            error={getErros.includes('LinkDominioExterno')}
                            onChange={handleInputChange}
                            inputProps={{
                              maxLength: 100,
                            }}
                            autoComplete="off"
                          />
                        </Paper>
                      </Grid>
                      <Grid item xs={6}>
                        <label className={classes.label}>Data Abertura Empresa</label>
                        <Paper className={classes.medium} elevation={0}>
                          <InputMask
                            mask="99/99/9999"
                            value={
                              inputs.dataAberturaEmpresa &&
                              formatDateToRender(inputs.dataAberturaEmpresa)
                            }
                            name="dataAberturaEmpresa"
                            autocomplete="off"
                            onBlur={(event) =>
                              getErros.includes('DataAberturaEmpresa') &&
                              setErros(
                                getErros.filter(function (item) {
                                  return item !== 'DataAberturaEmpresa';
                                }),
                              )
                            }
                            disabled={false}
                            onChange={handleInputChange}
                          >
                            {() => (
                              <Input
                                className={classes.input}
                                name="dataAberturaEmpresa"
                                placeholder="DATA ABERTURA EMPRESA"
                                error={getErros.includes('DataAberturaEmpresa')}
                              />
                            )}
                          </InputMask>
                        </Paper>
                      </Grid>
                      <Grid item xs={4}>
                        <label className={classes.label}>Telefone Comercial</label>
                        <Paper className={classes.medium} elevation={0}>
                          <PhoneMask
                            value={inputs.telefoneComercialNumero}
                            name="telefoneComercialNumero"
                            autocomplete="off"
                            error={getErros.includes('TelefoneComercialNumero')}
                            onBlur={event => getErros.includes('TelefoneComercialNumero') && setErros(
                              getErros.filter(function (item) {
                                return item !== 'TelefoneComercialNumero'
                              })
                            )}
                            className={classes.input}
                            placeholder="Telefone Comercial"
                            onChange={handleInputChange}
                          />
                        </Paper>
                      </Grid>
                      <Grid item xs={12}>
                        <label className={classes.label}>Tela de Operações Infromações</label>
                        <Paper elevation={0} className={classes.medium}>
                          <TextField
                            multiline
                            rows={5}
                            name="telaDeOperacoesInformacoes"
                            inputProps={{ disableUnderline: true, style: { textTransform: 'uppercase' } }}
                            value={inputs.telaDeOperacoesInformacoes}
                            onChange={handleInputChange}
                            error={getErros.includes('TelaDeOperacoesInformacoes')}
                            onBlur={event => getErros.includes('TelaDeOperacoesInformacoes') && setErros(
                              getErros.filter(function (item) {
                                return item !== 'TelaDeOperacoesInformacoes'
                              })
                            )}
                            className={classes.input}
                            style={{ height: 'auto' }}
                          />
                        </Paper>
                      </Grid>
                    </Grid>
                  </AccordionDetails>
                </Accordion>
                <Accordion defaultExpanded>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                    className={classes.summary}
                  >
                    <Typography className={classes.heading}>Financeiro</Typography>
                  </AccordionSummary>
                  <AccordionDetails className={classes.details}>
                    <Grid container>
                      <Grid item xs={3}>
                        <label className={classes.label}>
                          CDI com Atualização Automática
                        </label>
                        <Paper className={classes.medium} elevation={0}>
                          <NativeSelect
                            className={classes.input}
                            value={inputs.custoCdiAtualizacaoAutomatica}
                            name="custoCdiAtualizacaoAutomatica"
                            onChange={handleInputChange}
                            error={getErros.includes('custoCdiAtualizacaoAutomatica')}
                            onBlur={(event) =>
                              getErros.includes('custoCdiAtualizacaoAutomatica') &&
                              setErros(
                                getErros.filter(function (item) {
                                  return item !== 'custoCdiAtualizacaoAutomatica';
                                }),
                              )
                            }
                          >
                            <option value={"Sim"}>
                              Sim
                            </option>
                            <option selected value={"Nao"}>Não</option>
                          </NativeSelect>
                        </Paper>
                      </Grid>
                      <Grid item xs={3}>
                        <label className={classes.label}>Custo CDI</label>
                        <Paper className={classes.medium} elevation={0}>
                          <CurrencyTextField
                            value={inputs.custoCdi !== '0,00' ? inputs.custoCdi : 0}
                            currencySymbol="%"
                            placeholder="Custo CDI"
                            decimalCharacter=","
                            minimumValue="0"
                            maximumValue="100"
                            //disabled={inputs.custoCdiAtualizacaoAutomatica == 1}
                            style={{
                              padding: 0,
                              width: '100%',
                            }}
                            modifyValueOnWheel={false}
                            InputProps={{
                              className: classes.inputSalario,
                            }}
                            digitGroupSeparator="."
                            name="custoCdi"
                            error={getErros.includes('CustoCdi')}
                            onChange={handleInputNumberChange}
                            onBlur={(event) =>
                              getErros.includes('CustoCdi') &&
                              setErros(
                                getErros.filter(function (item) {
                                  return item !== 'CustoCdi';
                                }),
                              )
                            }
                          />
                          <span className={classes.porcentage}>%</span>
                        </Paper>
                      </Grid>
                      <Grid item xs={6}>
                        <label className={classes.label}>Mínimo dias para pagamento</label>
                        <Paper className={classes.medium} elevation={0}>
                          <Input
                            type="text"
                            className={classes.input}
                            placeholder="Mínimo dias para pagamento"
                            name="minimoDiasParaPagamento"
                            autocomplete="off"
                            onBlur={(event) =>
                              getErros.includes('MinimoDiasParaPagamento') &&
                              setErros(
                                getErros.filter(function (item) {
                                  return item !== 'MinimoDiasParaPagamento';
                                }),
                              )
                            }
                            error={getErros.includes('MinimoDiasParaPagamento')}
                            inputProps={{
                              maxLength: 2,
                            }}
                            value={inputs.minimoDiasParaPagamento}
                            onChange={(event) => {
                              if (event.target.value !== '') {
                                if (/^[0-9\b]+$/.test(event.target.value)) {
                                  handleInputChange(event);
                                }
                              } else {
                                handleInputChange(event);
                              }
                            }}
                          />
                        </Paper>
                      </Grid>
                      <Grid item xs={6}>
                        <label className={classes.label}>Taxa percentual mínimo rede</label>
                        <Paper className={classes.medium} elevation={0}>

                          <CurrencyTextField
                            value={
                              inputs.taxaPercentualMinimoAncora !== '0,00'
                                ? inputs.taxaPercentualMinimoAncora
                                : 0
                            }
                            currencySymbol=""
                            placeholder="Taxa percentual mínimo rede"
                            decimalCharacter=","
                            style={{
                              padding: 0,
                              width: '100%',
                            }}
                            modifyValueOnWheel={false}
                            minimumValue="-1"
                            maximumValue="100"
                            InputProps={{
                              className: classes.inputSalario,
                            }}
                            digitGroupSeparator="."
                            name="taxaPercentualMinimoAncora"
                            error={getErros.includes('TaxaPercentualMinimoAncora')}
                            onChange={handleInputNumberChange}
                            onBlur={(event) =>
                              getErros.includes('TaxaPercentualMinimoAncora') &&
                              setErros(
                                getErros.filter(function (item) {
                                  return item !== 'TaxaPercentualMinimoAncora';
                                }),
                              )
                            }
                          />
                          <span className={classes.porcentage}>%</span>
                        </Paper>
                      </Grid>
                      <Grid item xs={6}>
                        <label className={classes.label}>Taxa percentual mínimo capittale</label>
                        <Paper className={classes.medium} elevation={0}>
                          <CurrencyTextField
                            value={
                              inputs.taxaPercentualMinimoCapittale !== '0,00'
                                ? inputs.taxaPercentualMinimoCapittale
                                : "0"
                            }
                            currencySymbol=""
                            placeholder="Taxa percentual mínimo rede"
                            decimalCharacter=","
                            style={{
                              padding: 0,
                              width: '100%',
                            }}
                            modifyValueOnWheel={false}
                            InputProps={{
                              className: classes.inputSalario,
                            }}
                            minimumValue="0"
                            maximumValue="100"
                            digitGroupSeparator="."
                            name="taxaPercentualMinimoCapittale"
                            error={getErros.includes('TaxaPercentualMinimoCapittale')}
                            onChange={handleInputNumberChange}
                            onBlur={(event) =>
                              getErros.includes('TaxaPercentualMinimoCapittale') &&
                              setErros(
                                getErros.filter(function (item) {
                                  return item !== 'TaxaPercentualMinimoCapittale';
                                }),
                              )
                            }
                          />
                          <span className={classes.porcentage}>%</span>
                        </Paper>
                      </Grid>
                      <Grid item xs={6}>
                        <label className={classes.label}>Taxa media mínimo mês rede</label>
                        <Paper className={classes.medium} elevation={0}>
                          <CurrencyTextField
                            value={
                              inputs.taxaMediaMinimoMesRede !== '0,00'
                                ? inputs.taxaMediaMinimoMesRede
                                : "0"
                            }
                            currencySymbol=""
                            placeholder="Taxa percentual mínimo rede"
                            decimalCharacter=","
                            style={{
                              padding: 0,
                              width: '100%',
                            }}
                            modifyValueOnWheel={false}
                            InputProps={{
                              className: classes.inputSalario,
                            }}
                            minimumValue="0"
                            maximumValue="100"
                            digitGroupSeparator="."
                            name="taxaMediaMinimoMesRede"
                            error={getErros.includes('TaxaMediaMinimoMesRede')}
                            onChange={handleInputNumberChange}
                            onBlur={(event) =>
                              getErros.includes('TaxaMediaMinimoMesRede') &&
                              setErros(
                                getErros.filter(function (item) {
                                  return item !== 'TaxaMediaMinimoMesRede';
                                }),
                              )
                            }
                          />
                          <span className={classes.porcentage}>%</span>
                        </Paper>
                      </Grid>
                      <Grid item xs={6}>
                        <label className={classes.label}>Conta corrente limite diário</label>
                        <Paper className={classes.medium} elevation={0}>
                          <CurrencyTextField
                            value={
                              inputs.contaCorrenteLimiteDiario !== '0,00'
                                ? inputs.contaCorrenteLimiteDiario
                                : 0
                            }
                            currencySymbol="R$"
                            placeholder="Conta corrente limite diário"
                            decimalCharacter=","
                            style={{
                              padding: 0,
                              width: '100%',
                            }}
                            modifyValueOnWheel={false}
                            InputProps={{
                              className: classes.inputSalario,
                            }}
                            digitGroupSeparator="."
                            name="contaCorrenteLimiteDiario"
                            error={getErros.includes('ContaCorrenteLimiteDiario')}
                            onChange={handleInputNumberChange}
                            onBlur={(event) =>
                              getErros.includes('ContaCorrenteLimiteDiario') &&
                              setErros(
                                getErros.filter(function (item) {
                                  return item !== 'ContaCorrenteLimiteDiario';
                                }),
                              )
                            }
                          />
                        </Paper>
                      </Grid>

                      <Grid item xs={6}>
                        <label className={classes.label}>Conta corrente limite mensal</label>
                        <Paper className={classes.medium} elevation={0}>
                          <CurrencyTextField
                            value={
                              inputs.contaCorrenteLimiteMensal !== '0,00'
                                ? inputs.contaCorrenteLimiteMensal
                                : 0
                            }
                            currencySymbol="R$"
                            placeholder="Conta corrente limite mensal"
                            decimalCharacter=","
                            style={{
                              padding: 0,
                              width: '100%',
                            }}
                            InputProps={{
                              className: classes.inputSalario,
                            }}
                            modifyValueOnWheel={false}
                            digitGroupSeparator="."
                            name="contaCorrenteLimiteMensal"
                            error={getErros.includes('ContaCorrenteLimiteMensal')}
                            onChange={handleInputNumberChange}
                            onBlur={(event) =>
                              getErros.includes('ContaCorrenteLimiteMensal') &&
                              setErros(
                                getErros.filter(function (item) {
                                  return item !== 'ContaCorrenteLimiteMensal';
                                }),
                              )
                            }
                          />
                        </Paper>
                      </Grid>
                      <Grid item xs={6}>
                        <label className={classes.label}>Fechamento Mês</label>
                        <Paper className={classes.medium} elevation={0}>
                          <NativeSelect
                            className={classes.input}
                            value={inputs.fechamentoMes}
                            name="fechamentoMes"
                            onChange={handleInputChange}
                            error={getErros.includes('fechamentoMes')}
                            onBlur={(event) =>
                              getErros.includes('fechamentoMes') &&
                              setErros(
                                getErros.filter(function (item) {
                                  return item !== 'fechamentoMes';
                                }),
                              )
                            }
                          >
                            <option selected value="MesAnterior">
                              Mês Anterior
                            </option>
                            <option value="MesAtual">Mês Atual</option>
                          </NativeSelect>
                        </Paper>
                      </Grid>

                      <Grid item xs={6}>
                        <label className={classes.label}>
                          Questionar Fornecedor Boleto Emitido
                        </label>
                        <Paper className={classes.medium} elevation={0}>
                          <NativeSelect
                            className={classes.input}
                            value={inputs.questionarFornecedoresBoletosEmitidos}
                            name="questionarFornecedoresBoletosEmitidos"
                            onChange={handleInputChange}
                            error={getErros.includes('questionarFornecedoresBoletosEmitidos')}
                            onBlur={(event) =>
                              getErros.includes('questionarFornecedoresBoletosEmitidos') &&
                              setErros(
                                getErros.filter(function (item) {
                                  return item !== 'questionarFornecedoresBoletosEmitidos';
                                }),
                              )
                            }
                          >
                            <option selected value="Sim">
                              Sim
                            </option>
                            <option value="Nao">Não</option>
                          </NativeSelect>
                        </Paper>
                      </Grid>
                      <Grid item xs={6}>
                        <label className={classes.label}>Destino de Pagamento</label>
                        <Paper className={classes.medium} elevation={0}>
                          <NativeSelect
                            className={classes.input}
                            value={inputs.destinoPagamentoId}
                            name="destinoPagamentoId"
                            onChange={handleInputChange}
                            error={getErros.includes('destinoPagamentoId')}
                            onBlur={(event) =>
                              getErros.includes('destinoPagamentoId') &&
                              setErros(
                                getErros.filter(function (item) {
                                  return item !== 'destinoPagamentoId';
                                }),
                              )
                            }
                          >
                            {destinoOpcoes.map((destino) => (
                              <option key={destino.destinoPagamentoId} value={destino.destinoPagamentoId.toString()}>
                                {capitalizeFirstLetter(destino.destinoPagamento)}
                              </option>
                            ))}
                          </NativeSelect>
                        </Paper>
                      </Grid>

                      <Grid item xs={6}>
                        <label className={classes.label}>Valor Mínimo para Qualificado</label>
                        <Paper className={classes.medium} elevation={0}>
                          <CurrencyTextField
                            value={
                              inputs.valorMinimoParaQualificado !== '0,00'
                                ? inputs.valorMinimoParaQualificado
                                : 0
                            }
                            currencySymbol="R$"
                            placeholder="Valor Mínimo para Qualificado"
                            decimalCharacter=","
                            style={{
                              padding: 0,
                              width: '100%',
                            }}
                            InputProps={{
                              className: classes.inputSalario,
                            }}
                            modifyValueOnWheel={false}
                            digitGroupSeparator="."
                            name="valorMinimoParaQualificado"
                            error={getErros.includes('ValorMinimoParaQualificado')}
                            onChange={handleInputNumberChange}
                            onBlur={(event) =>
                              getErros.includes('ValorMinimoParaQualificado') &&
                              setErros(
                                getErros.filter(function (item) {
                                  return item !== 'ValorMinimoParaQualificado';
                                }),
                              )
                            }
                          />
                        </Paper>
                      </Grid>
                      <Grid item xs={6}>
                        <label className={classes.label}>Valor Tarifa Bancaria (FIDC)</label>
                        <Paper className={classes.medium} elevation={0}>
                          <CurrencyTextField
                            value={
                              inputs.bancoFidcValorTarifaBancaria !== '0,00'
                                ? inputs.bancoFidcValorTarifaBancaria
                                : 0
                            }
                            currencySymbol="R$"
                            placeholder="Valor Tarifa Bancaria (FIDC)"
                            decimalCharacter=","
                            style={{
                              padding: 0,
                              width: '100%',
                            }}
                            InputProps={{
                              className: classes.inputSalario,
                            }}
                            modifyValueOnWheel={false}
                            digitGroupSeparator="."
                            name="bancoFidcValorTarifaBancaria"
                            error={getErros.includes('BancoFidcValorTarifaBancaria')}
                            onChange={handleInputNumberChange}
                            onBlur={(event) =>
                              getErros.includes('BancoFidcValorTarifaBancaria') &&
                              setErros(
                                getErros.filter(function (item) {
                                  return item !== 'BancoFidcValorTarifaBancaria';
                                }),
                              )
                            }
                          />
                        </Paper>
                      </Grid>
                      <Grid item xs={6}>
                        <label className={classes.label}>Valor Mínimo para não Qualificado</label>
                        <Paper className={classes.medium} elevation={0}>
                          <CurrencyTextField
                            value={
                              inputs.valorMinimoParaNaoQualificado !== '0,00'
                                ? inputs.valorMinimoParaNaoQualificado
                                : 0
                            }
                            currencySymbol="R$"
                            placeholder="Valor Mínimo para não Qualificado"
                            decimalCharacter=","
                            style={{
                              padding: 0,
                              width: '100%',
                            }}
                            InputProps={{
                              className: classes.inputSalario,
                            }}
                            modifyValueOnWheel={false}
                            digitGroupSeparator="."
                            name="valorMinimoParaNaoQualificado"
                            error={getErros.includes('ValorMinimoParaNaoQualificado')}
                            onChange={handleInputNumberChange}
                            onBlur={(event) =>
                              getErros.includes('ValorMinimoParaNaoQualificado') &&
                              setErros(
                                getErros.filter(function (item) {
                                  return item !== 'ValorMinimoParaNaoQualificado';
                                }),
                              )
                            }
                          />
                        </Paper>
                      </Grid>
                      <Grid item xs={6}>
                        <label className={classes.label}>Questionar Fornecedor Aceita Abatimentos/Descontos</label>
                        <Paper className={classes.medium} elevation={0}>
                          <NativeSelect
                            className={classes.input}
                            value={inputs.questionarFornecedoresAceitaAbatimentosDescontos}
                            name="questionarFornecedoresAceitaAbatimentosDescontos"
                            onChange={handleInputChange}
                            error={getErros.includes('QuestionarFornecedoresAceitaAbatimentosDescontos')}
                            onBlur={(event) =>
                              getErros.includes('QuestionarFornecedoresAceitaAbatimentosDescontos') &&
                              setErros(
                                getErros.filter(function (item) {
                                  return item !== 'QuestionarFornecedoresAceitaAbatimentosDescontos';
                                }),
                              )
                            }
                          >
                            <option selected value="Nao">
                              Não
                            </option>
                            <option value="Sim">Sim</option>
                          </NativeSelect>
                        </Paper>
                      </Grid>
                      <Grid item xs={6}>
                        <label className={classes.label}>Obriga Digito Agencia</label>
                        <Paper className={classes.medium} elevation={0}>
                          <NativeSelect
                            className={classes.input}
                            value={inputs.obrigaDigitoAgencia}
                            name="obrigaDigitoAgencia"
                            onChange={handleInputChange}
                            error={getErros.includes('ObrigaDigitoAgencia')}
                            onBlur={(event) =>
                              getErros.includes('ObrigaDigitoAgencia') &&
                              setErros(
                                getErros.filter(function (item) {
                                  return item !== 'ObrigaDigitoAgencia';
                                }),
                              )
                            }
                          >
                            <option selected value="Nao">
                              Não
                            </option>
                            <option value="Sim">Sim</option>
                          </NativeSelect>
                        </Paper>
                      </Grid>
                      <Grid item xs={6}>
                        <label className={classes.label}>Tipos Dados Bancarios</label>
                        <Paper className={classes.medium} elevation={0}>
                          <NativeSelect
                            className={classes.input}
                            value={inputs.tiposDadosBancarios}
                            name="tiposDadosBancarios"
                            onChange={handleInputChange}
                            error={getErros.includes('tiposDadosBancarios')}
                            onBlur={(event) =>
                              getErros.includes('tiposDadosBancarios') &&
                              setErros(
                                getErros.filter(function (item) {
                                  return item !== 'tiposDadosBancarios';
                                }),
                              )
                            }
                          >
                            <option selected value="Todos">
                              Todos
                            </option>
                            <option value="SomenteDadosBancarios">Somente Dados Bancarios</option>
                            <option value="SomentePix">Somente Pix</option>
                          </NativeSelect>
                        </Paper>
                      </Grid>
                      <Grid item xs={6}>
                        <label className={classes.label}>Tipos Resumo Diario</label>
                        <Paper className={classes.medium} elevation={0}>
                          <NativeSelect
                            className={classes.input}
                            value={inputs.tipoResumoDiario}
                            name="tipoResumoDiario"
                            onChange={handleInputChange}
                            error={getErros.includes('tipoResumoDiario')}
                            onBlur={(event) =>
                              getErros.includes('tipoResumoDiario') &&
                              setErros(
                                getErros.filter(function (item) {
                                  return item !== 'tipoResumoDiario';
                                }),
                              )
                            }
                          >
                            <option value="Desativado">
                              Desativado
                            </option>
                            <option value="TodasAsAntecipacoes">Todas as Antecipações</option>
                            <option selected value="ApenasPagamentoDMais1">Apenas Pagamento de Mais 1</option>
                          </NativeSelect>
                        </Paper>
                      </Grid>
                      <Grid item xs={6}>
                        <label className={classes.label}>Horário Resumo Pendente</label>
                        <Paper className={classes.medium} elevation={0}>
                          <Input
                            type="time"
                            className={classes.input}
                            value={inputs.horaResumoPendente || ''}
                            name="horaResumoPendente"
                            onChange={handleInputChange}
                            inputProps={{ step: 60 }}
                          />
                        </Paper>
                      </Grid>
                      <Grid item xs={6}>
                        <label className={classes.label}>Controla Corporate</label>
                        <Paper className={classes.medium} elevation={0}>
                          <NativeSelect
                            className={classes.input}
                            value={inputs.controlaCorporate}
                            name="controlaCorporate"
                            onChange={handleInputChange}
                            error={getErros.includes('ControlaCorporate')}
                            onBlur={(event) =>
                              getErros.includes('ControlaCorporate') &&
                              setErros(
                                getErros.filter(function (item) {
                                  return item !== 'ControlaCorporate';
                                }),
                              )
                            }
                          >
                            <option selected value="Nao">
                              Não
                            </option>
                            <option value="Sim">Sim</option>
                          </NativeSelect>
                        </Paper>
                      </Grid>
                    </Grid>
                  </AccordionDetails>
                </Accordion>

                <Accordion defaultExpanded>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                    className={classes.summary}
                  >
                    <Typography className={classes.heading}>
                      Importação de arquivo de titulos
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails className={classes.details}>
                    <Grid container>
                      <Grid item xs={12}>
                        <label className={classes.label}>Importação Via</label>
                        <Paper className={classes.medium} elevation={0}>
                          <NativeSelect
                            className={classes.input}
                            value={inputs.importacaoVia || 'Arquivo'}
                            name="importacaoVia"
                            onChange={handleInputChange}
                          >
                            <option value="Arquivo">Arquivo</option>
                            <option value="Api">Api</option>
                          </NativeSelect>
                        </Paper>
                      </Grid>
                      <Grid item xs={6}>
                        <label className={classes.label}>Layout arquivos titulos importação</label>
                        <Paper className={classes.medium} elevation={0}>
                          <NativeSelect
                            className={classes.input}
                            value={inputs.layoutArquivoImportacaoId}
                            name="layoutArquivoImportacaoId"
                            onChange={handleInputChange}
                            error={getErros.includes('LayoutArquivoImportacaoId')}
                            onBlur={(event) =>
                              getErros.includes('LayoutArquivoImportacaoId') &&
                              setErros(
                                getErros.filter(function (item) {
                                  return item !== 'LayoutArquivoImportacaoId';
                                }),
                              )
                            }
                          >
                            <option value="0">FALTA PREENCHER</option>
                            {getLayoutsArquivoTitulosImportação.map(
                              (layoutsArquivoTitulosImportação) => (
                                <option
                                  key={layoutsArquivoTitulosImportação.layoutArquivoImportacaoId}
                                  value={layoutsArquivoTitulosImportação.layoutArquivoImportacaoId}
                                >
                                  {layoutsArquivoTitulosImportação.nome}
                                </option>
                              ),
                            )}
                          </NativeSelect>
                        </Paper>
                      </Grid>
                      <Grid item xs={6}>
                        <label className={classes.label}>Processando arquivo</label>
                        <Paper className={classes.medium} elevation={0}>
                          <NativeSelect
                            className={classes.input}
                            value={inputs.processandoArquivo}
                            name="processandoArquivo"
                            onChange={handleInputChange}
                            error={getErros.includes('ProcessandoArquivo')}
                            onBlur={(event) =>
                              getErros.includes('ProcessandoArquivo') &&
                              setErros(
                                getErros.filter(function (item) {
                                  return item !== 'ProcessandoArquivo';
                                }),
                              )
                            }
                          >
                            <option selected value="Nao">
                              Não
                            </option>
                            <option value="Sim">Sim</option>
                          </NativeSelect>
                        </Paper>
                      </Grid>
                      <Grid item xs={6}>
                        <label className={classes.label}>Nome pasta arquivos titulos</label>
                        <Paper className={classes.medium} elevation={0}>
                          <Input
                            className={classes.input}
                            placeholder="Nome Pasta Arquivo Titulos"
                            value={inputs.nomePastaArquivos}
                            name="nomePastaArquivos"
                            classes={{ input: classes.inputText }}
                            onBlur={(event) =>
                              getErros.includes('NomePastaArquivos') &&
                              setErros(
                                getErros.filter(function (item) {
                                  return item !== 'NomePastaArquivos';
                                }),
                              )
                            }
                            error={getErros.includes('NomePastaArquivos')}
                            onChange={handleInputChange}
                            autoComplete="off"
                            inputProps={{
                              maxLength: 100,
                            }}
                          />
                        </Paper>
                      </Grid>
                      <Grid item xs={6}>
                        <label className={classes.label}>Vencimento de Titulo em Dias</label>
                        <Paper className={classes.medium} elevation={0}>
                          <Input
                            type="text"
                            className={classes.input}
                            placeholder="Vencimento Titulo Em Dias"
                            name="vencimentoTituloEmDMais"
                            autocomplete="off"
                            onBlur={(event) =>
                              getErros.includes('VencimentoTituloEmDMais') &&
                              setErros(
                                getErros.filter(function (item) {
                                  return item !== 'VencimentoTituloEmDMais';
                                }),
                              )
                            }
                            error={getErros.includes('VencimentoTituloEmDMais')}
                            value={inputs.vencimentoTituloEmDMais}
                            onChange={(event) => {
                              if (event.target.value !== '') {
                                if (/^[0-9\b]+$/.test(event.target.value)) {
                                  handleInputChange(event);
                                }
                              } else {
                                handleInputChange(event);
                              }
                            }}
                          />
                        </Paper>
                      </Grid>
                      <Grid item xs={6}>
                        <label className={classes.label}>Tipo Loja Codigo</label>
                        <Paper className={classes.medium} elevation={0}>
                          <NativeSelect
                            className={classes.input}
                            value={inputs.tipoLojaCodigo}
                            name="tipoLojaCodigo"
                            onChange={handleInputChange}
                            error={getErros.includes('tipoLojaCodigo')}
                            onBlur={(event) =>
                              getErros.includes('tipoLojaCodigo') &&
                              setErros(
                                getErros.filter(function (item) {
                                  return item !== 'tipoLojaCodigo';
                                }),
                              )
                            }
                          >
                            <option selected value="Alfabetico">
                              Alfabético
                            </option>
                            <option value="Numerico">Numérico</option>
                          </NativeSelect>
                        </Paper>
                      </Grid>
                      <Grid item xs={6}>
                        <label className={classes.label}>Controla loja</label>
                        <Paper className={classes.medium} elevation={0}>
                          <NativeSelect
                            className={classes.input}
                            value={inputs.controlaLoja}
                            name="controlaLoja"
                            onChange={handleInputChange}
                            error={getErros.includes('ControlaLoja')}
                            onBlur={(event) =>
                              getErros.includes('ControlaLoja') &&
                              setErros(
                                getErros.filter(function (item) {
                                  return item !== 'ControlaLoja';
                                }),
                              )
                            }
                          >
                            <option selected value="Nao">
                              Não
                            </option>
                            <option value="Sim">Sim</option>
                          </NativeSelect>
                        </Paper>
                      </Grid>
                      <Grid item xs={6}>
                        <label className={classes.label}>Enviar Emails de Interesse Após Processar Arquivo</label>
                        <Paper className={classes.medium} elevation={0}>
                          <NativeSelect
                            className={classes.input}
                            value={inputs.enviarEmailsDeInteresseAposProcessarArquivo}
                            name="enviarEmailsDeInteresseAposProcessarArquivo"
                            onChange={handleInputChange}
                            error={getErros.includes('EnviarEmailsDeInteresseAposProcessarArquivo')}
                            onBlur={(event) =>
                              getErros.includes('EnviarEmailsDeInteresseAposProcessarArquivo') &&
                              setErros(
                                getErros.filter(function (item) {
                                  return item !== 'EnviarEmailsDeInteresseAposProcessarArquivo';
                                }),
                              )
                            }
                          >
                            <option selected value="Nao">
                              Não
                            </option>
                            <option value="Sim">Sim</option>
                          </NativeSelect>
                        </Paper>
                      </Grid>
                      <Grid item xs={6}>
                        <label className={classes.label}>Enviar WhatsApp Após Processar Arquivo</label>
                        <Paper className={classes.medium} elevation={0}>
                          <NativeSelect
                            className={classes.input}
                            value={inputs.enviarWhatsAppAposProcessarArquivo}
                            name="enviarWhatsAppAposProcessarArquivo"
                            onChange={handleInputChange}
                            error={getErros.includes('EnviarWhatsAppAposProcessarArquivo')}
                            onBlur={(event) =>
                              getErros.includes('EnviarWhatsAppAposProcessarArquivo') &&
                              setErros(
                                getErros.filter(function (item) {
                                  return item !== 'EnviarWhatsAppAposProcessarArquivo';
                                }),
                              )
                            }
                          >
                            <option selected value="Nao">
                              Não
                            </option>
                            <option value="Sim">Sim</option>
                          </NativeSelect>
                        </Paper>
                      </Grid>
                    </Grid>
                  </AccordionDetails>
                </Accordion>

                <Accordion defaultExpanded>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                    className={classes.summary}
                  >
                    <Typography className={classes.heading}>
                      Exportação propostas aprovadas
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails className={classes.details}>
                    <Grid container>
                      <Grid item xs={6}>
                        <label className={classes.label}>Layout arquivos titulos exportação</label>
                        <Paper className={classes.medium} elevation={0}>
                          <NativeSelect
                            className={classes.input}
                            value={inputs.layoutArquivoExportacaoId}
                            name="layoutArquivoExportacaoId"
                            onChange={handleInputChange}
                            error={getErros.includes('LayoutArquivoExportacaoId')}
                            onBlur={(event) =>
                              getErros.includes('LayoutArquivoExportacaoId') &&
                              setErros(
                                getErros.filter(function (item) {
                                  return item !== 'LayoutArquivoExportacaoId';
                                }),
                              )
                            }
                          >
                            <option value="0">FALTA PREENCHER</option>
                            {getLayoutsArquivoTituloExportação.map(
                              (layoutsArquivoTitulosExportação) => (
                                <option
                                  key={layoutsArquivoTitulosExportação.layoutArquivoExportacaoId}
                                  value={layoutsArquivoTitulosExportação.layoutArquivoExportacaoId}
                                >
                                  {layoutsArquivoTitulosExportação.nome}
                                </option>
                              ),
                            )}
                          </NativeSelect>
                        </Paper>
                      </Grid>
                      <Grid item xs={6}>
                        <label className={classes.label}>Enviar Arquivo Exportação na Aprovação</label>
                        <Paper className={classes.medium} elevation={0}>
                          <NativeSelect
                            className={classes.input}
                            value={inputs.enviarArquivoExportacaoNaAprovacao}
                            name="enviarArquivoExportacaoNaAprovacao"
                            onChange={handleInputChange}
                            error={getErros.includes('EnviarArquivoExportacaoNaAprovacao')}
                            onBlur={(event) =>
                              getErros.includes('EnviarArquivoExportacaoNaAprovacao') &&
                              setErros(
                                getErros.filter(function (item) {
                                  return item !== 'EnviarArquivoExportacaoNaAprovacao';
                                }),
                              )
                            }
                          >
                            <option selected value="Nao">
                              Não
                            </option>
                            <option value="Sim">Sim</option>
                          </NativeSelect>
                        </Paper>
                      </Grid>
                      <Grid item xs={6}>
                        <label className={classes.label}>Ftp Status</label>
                        <Paper className={classes.medium} elevation={0}>
                          <NativeSelect
                            className={classes.input}
                            value={inputs.ftpStatus}
                            name="ftpStatus"
                            onChange={handleInputChange}
                            error={getErros.includes('ftpStatus')}
                            onBlur={(event) =>
                              getErros.includes('ftpStatus') &&
                              setErros(
                                getErros.filter(function (item) {
                                  return item !== 'ftpStatus';
                                }),
                              )
                            }
                          >
                            <option selected value="Inativo">
                              Inativo
                            </option>
                            <option value="Ativo">Ativo</option>
                          </NativeSelect>
                        </Paper>
                      </Grid>
                      <Grid item xs={6}>
                        <label className={classes.label}>Envio Automático Propostas Aprovadas Para a Rede</label>
                        <Paper className={classes.medium} elevation={0}>
                          <NativeSelect
                            className={classes.input}
                            value={inputs.envioAutomaticoPropostasAprovadas}
                            name="envioAutomaticoPropostasAprovadas"
                            onChange={handleInputChange}
                            error={getErros.includes('EnvioAutomaticoPropostasAprovadas')}
                            onBlur={(event) =>
                              getErros.includes('EnvioAutomaticoPropostasAprovadas') &&
                              setErros(
                                getErros.filter(function (item) {
                                  return item !== 'EnvioAutomaticoPropostasAprovadas';
                                }),
                              )
                            }
                          >
                            <option selected value="Nao">
                              Não
                            </option>
                            <option value="SimComEmail">Sim, com e-mail</option>
                            <option value="SimSemEmail">Sim, sem e-mail</option>
                          </NativeSelect>
                        </Paper>
                      </Grid>

                      <Grid item xs={6}>
                        <label className={classes.label}>Ftp User Name</label>
                        <Paper className={classes.medium} elevation={0}>
                          <Input
                            className={classes.input}
                            placeholder="Ftp Name"
                            value={inputs.ftpUserName}
                            name="ftpUserName"
                            onBlur={(event) =>
                              getErros.includes('FtpUserName') &&
                              setErros(
                                getErros.filter(function (item) {
                                  return item !== 'FtpUserName';
                                }),
                              )
                            }
                            error={getErros.includes('FtpUserName')}
                            onChange={handleInputChange}
                            autoComplete="off"
                            inputProps={{
                              maxLength: 100,
                            }}
                          />
                        </Paper>
                      </Grid>
                      <Grid item xs={6}>
                        <label className={classes.label}>Ftp Password</label>
                        <Paper className={classes.medium} elevation={0}>
                          <Input
                            className={classes.input}
                            placeholder="Ftp Password"
                            value={inputs.ftpPassword}
                            name="ftpPassword"
                            onBlur={(event) =>
                              getErros.includes('FtpPassword') &&
                              setErros(
                                getErros.filter(function (item) {
                                  return item !== 'FtpPassword';
                                }),
                              )
                            }
                            error={getErros.includes('FtpPassword')}
                            onChange={handleInputChange}
                            autoComplete="off"
                            inputProps={{
                              maxLength: 100,
                            }}
                          />
                        </Paper>
                      </Grid>
                      <Grid item xs={6}>
                        <label className={classes.label}>Ftp Protocolo</label>
                        <Paper className={classes.medium} elevation={0}>
                          <NativeSelect
                            className={classes.input}
                            value={inputs.ftpProtocolo}
                            name="ftpProtocolo"
                            onChange={handleInputChange}
                            error={getErros.includes('ftpProtocolo')}
                            onBlur={(event) =>
                              getErros.includes('ftpProtocolo') &&
                              setErros(
                                getErros.filter(function (item) {
                                  return item !== 'ftpProtocolo';
                                }),
                              )
                            }
                          >
                            <option selected value="Ftp">
                              Ftp
                            </option>
                            <option value="Sftp">Sftp</option>
                          </NativeSelect>
                        </Paper>
                      </Grid>
                      <Grid item xs={6}>
                        <label className={classes.label}>Ftp Host</label>
                        <Paper className={classes.medium} elevation={0}>
                          <Input
                            className={classes.input}
                            placeholder="Ftp Host"
                            value={inputs.ftpHost}
                            name="ftpHost"
                            onBlur={(event) =>
                              getErros.includes('FtpHost') &&
                              setErros(
                                getErros.filter(function (item) {
                                  return item !== 'FtpHost';
                                }),
                              )
                            }
                            error={getErros.includes('FtpHost')}
                            onChange={handleInputChange}
                            autoComplete="off"
                            inputProps={{
                              maxLength: 100,
                            }}
                          />
                        </Paper>
                      </Grid>
                      <Grid item xs={6}>
                        <label className={classes.label}>Ftp Port</label>
                        <Paper className={classes.medium} elevation={0}>
                          <Input
                            type="text"
                            className={classes.input}
                            placeholder="Ftp Port"
                            name="ftpPort"
                            autocomplete="off"
                            onBlur={(event) =>
                              getErros.includes('FtpPort') &&
                              setErros(
                                getErros.filter(function (item) {
                                  return item !== 'FtpPort';
                                }),
                              )
                            }
                            error={getErros.includes('FtpPort')}
                            inputProps={{
                              maxLength: 6,
                            }}
                            value={inputs.ftpPort}
                            onChange={(event) => {
                              if (event.target.value !== '') {
                                if (/^[0-9\b]+$/.test(event.target.value)) {
                                  handleInputChange(event);
                                }
                              } else {
                                handleInputChange(event);
                              }
                            }}
                          />
                        </Paper>
                      </Grid>
                      <Grid item xs={6}>
                        <label className={classes.label}>Ftp Directory</label>
                        <Paper className={classes.medium} elevation={0}>
                          <Input
                            className={classes.input}
                            placeholder="Ftp Directory"
                            value={inputs.ftpDirectory}
                            name="ftpDirectory"
                            onBlur={(event) =>
                              getErros.includes('FtpDirectory') &&
                              setErros(
                                getErros.filter(function (item) {
                                  return item !== 'FtpDirectory';
                                }),
                              )
                            }
                            error={getErros.includes('FtpDirectory')}
                            onChange={handleInputChange}
                            autoComplete="off"
                            inputProps={{
                              maxLength: 100,
                            }}
                          />
                        </Paper>
                      </Grid>
                    </Grid>
                  </AccordionDetails>
                </Accordion>

                <Accordion defaultExpanded>
  <AccordionSummary
    expandIcon={<ExpandMoreIcon />}
    aria-controls="panel1a-content"
    id="panel1a-header"
    className={classes.summary}
  >
    <Typography className={classes.heading}>Informações de e-mail</Typography>
  </AccordionSummary>
  <AccordionDetails className={classes.details}>
    <Grid container spacing={2}>

      {/* E-mail Conexão */}
      <Grid item xs={6}>
        <label className={classes.label}>E-mail Conexão</label>
        <Paper className={classes.medium} elevation={0}>
          <NativeSelect
            className={classes.input}
            value={inputs.emailConexao}
            name="emailConexao"
            onChange={handleInputChange}
          >
            <option value="Smtp">SMTP</option>
            <option value="SmtpComSsl">SMTP COM SSL</option>
            <option value="Exchange">EXCHANGE</option>
            <option value="AutenticacaoModerna">AUTENTICACAO MODERNA</option>
          </NativeSelect>
        </Paper>
      </Grid>

      {/* E-mail Exchange */}
      <Grid item xs={6}>
        <label className={classes.label}>E-mail Exchange</label>
        <Paper className={classes.medium} elevation={0}>
          <NativeSelect
            className={classes.input}
            value={inputs.emailExchange}
            name="emailExchange"
            onChange={handleInputChange}
          >
            <option value="Nao">Não</option>
            <option value="Exchange2007_SP1">Exchange 2007_SP1</option>
            <option value="Exchange2010">Exchange 2010</option>
            <option value="Exchange2010_SP1">Exchange 2010_SP1</option>
            <option value="Exchange2010_SP2">Exchange 2010_SP2</option>
            <option value="Exchange2013">Exchange 2013</option>
            <option value="Exchange2013_SP1">Exchange 2013_SP1</option>
          </NativeSelect>
        </Paper>
      </Grid>

      {/* E-mail Antecipação */}
      <Grid item xs={6}>
        <label className={classes.label}>E-mail Antecipação</label>
        <Paper className={classes.medium} elevation={0}>
          <Input
            className={classes.input}
            placeholder="E-mail Antecipação"
            value={inputs.emailAntecipacao}
            name="emailAntecipacao"
            onChange={handleInputChange}
            autoComplete="off"
            inputProps={{ maxLength: 100 }}
          />
        </Paper>
      </Grid>

      {/* E-mail UserName */}
      <Grid item xs={6}>
        <label className={classes.label}>E-mail UserName</label>
        <Paper className={classes.medium} elevation={0}>
          <Input
            className={classes.input}
            placeholder="E-mail UserName"
            value={inputs.emailUserName}
            name="emailUserName"
            onChange={handleInputChange}
            autoComplete="off"
            inputProps={{ maxLength: 100 }}
          />
        </Paper>
      </Grid>

      {/* E-mail Host */}
      <Grid item xs={6}>
        <label className={classes.label}>E-mail Host</label>
        <Paper className={classes.medium} elevation={0}>
          <Input
            className={classes.input}
            placeholder="E-mail Host"
            value={inputs.emailHost}
            name="emailHost"
            onChange={handleInputChange}
            autoComplete="off"
          />
        </Paper>
      </Grid>

      {/* E-mail Port */}
      <Grid item xs={6}>
        <label className={classes.label}>E-mail Port</label>
        <Paper className={classes.medium} elevation={0}>
          <Input
            className={classes.input}
            type="number"
            placeholder="E-mail Port"
            value={inputs.emailPort}
            name="emailPort"
            onChange={handleInputChange}
            autoComplete="off"
          />
        </Paper>
      </Grid>

      {/* E-mail Secure */}
      <Grid item xs={6}>
        <label className={classes.label}>E-mail Secure</label>
        <Paper className={classes.medium} elevation={0}>
          <NativeSelect
            className={classes.input}
            value={inputs.emailSecure}
            name="emailSecure"
            onChange={handleInputChange}
          >
            <option value="Desabilitado">Desabilitado</option>
            <option value="Habilitado">Habilitado</option>
          </NativeSelect>
        </Paper>
      </Grid>

      {/* E-mail Authentication */}
      <Grid item xs={6}>
        <label className={classes.label}>E-mail Authentication</label>
        <Paper className={classes.medium} elevation={0}>
          <NativeSelect
            className={classes.input}
            value={inputs.emailAuthentication}
            name="emailAuthentication"
            onChange={handleInputChange}
          >
            <option value="Desabilitado">Desabilitado</option>
            <option value="Habilitado">Habilitado</option>
          </NativeSelect>
        </Paper>
      </Grid>

      {/* E-mail Password */}
      <Grid item xs={6}>
        <label className={classes.label}>E-mail Password</label>
        <Paper className={classes.medium} elevation={0}>
          <Input
            className={classes.input}
            type="password"
            placeholder="E-mail Password"
            value={inputs.emailPassword}
            name="emailPassword"
            onChange={handleInputChange}
            autoComplete="off"
          />
        </Paper>
      </Grid>

      {/* ClientId */}
      <Grid item xs={6}>
        <label className={classes.label}>ClientId</label>
        <Paper className={classes.medium} elevation={0}>
          <Input
            className={classes.input}
            placeholder="ClientId"
            value={inputs.emailClientId}
            name="emailClientId"
            onChange={handleInputChange}
            autoComplete="off"
          />
        </Paper>
      </Grid>

      {/* EmailObjectId - NEW FIELD */}
      <Grid item xs={6}>
        <label className={classes.label}>ObjectId</label>
        <Paper className={classes.medium} elevation={0}>
          <Input
            className={classes.input}
            placeholder="ObjectId"
            value={inputs.emailObjectId}
            name="emailObjectId"
            onChange={handleInputChange}
            autoComplete="off"
            inputProps={{ maxLength: 36 }}
          />
        </Paper>
      </Grid>

      {/* TenanId */}
      <Grid item xs={6}>
        <label className={classes.label}>TenanId</label>
        <Paper className={classes.medium} elevation={0}>
          <Input
            className={classes.input}
            placeholder="TenanId"
            value={inputs.emailTenanId}
            name="emailTenanId"
            onChange={handleInputChange}
            autoComplete="off"
          />
        </Paper>
      </Grid>

      {/* EmailClientSecret - NEW FIELD */}
      <Grid item xs={6}>
        <label className={classes.label}>ClientSecret</label>
        <Paper className={classes.medium} elevation={0}>
          <Input
            className={classes.input}
            placeholder="ClientSecret"
            value={inputs.emailClientSecret}
            name="emailClientSecret"
            onChange={handleInputChange}
            autoComplete="off"
            inputProps={{ maxLength: 500 }}
          />
        </Paper>
      </Grid>

      {/* RedirectUri */}
      <Grid item xs={6}>
        <label className={classes.label}>RedirectUri</label>
        <Paper className={classes.medium} elevation={0}>
          <Input
            className={classes.input}
            placeholder="RedirectUri"
            value={inputs.emailRedirectUri}
            name="emailRedirectUri"
            onChange={handleInputChange}
            autoComplete="off"
          />
        </Paper>
      </Grid>

      {/* OutlookDomain */}
      <Grid item xs={6}>
        <label className={classes.label}>OutlookDomain</label>
        <Paper className={classes.medium} elevation={0}>
          <Input
            className={classes.input}
            placeholder="OutlookDomain"
            value={inputs.emailOutlookDomain}
            name="emailOutlookDomain"
            onChange={handleInputChange}
            autoComplete="off"
          />
        </Paper>
      </Grid>

      {/* AccessToken */}
      <Grid item xs={6}>
        <label className={classes.label}>AccessToken</label>
        <Paper className={classes.medium} elevation={0}>
          <Input
            className={classes.input}
            placeholder="AccessToken"
            value={inputs.emailAccessToken}
            name="emailAccessToken"
            disabled
            autoComplete="off"
          />
        </Paper>
      </Grid>

      {/* AccessTokenValidate */}
      <Grid item xs={6}>
        <label className={classes.label}>AccessTokenValidate</label>
        <Paper className={classes.medium} elevation={0}>
          <Input
            className={classes.input}
            placeholder="AccessTokenValidate"
            value={inputs.emailAccessTokenValidate ? new Date(inputs.emailAccessTokenValidate).toLocaleString('pt-BR') : ''}
            name="emailAccessTokenValidate"
            disabled
            autoComplete="off"
          />
        </Paper>
      </Grid>

      {/* RefreshTokenValidate */}
      <Grid item xs={6}>
        <label className={classes.label}>RefreshToken Validate</label>
        <Paper className={classes.medium} elevation={0}>
          <Input
            className={classes.input}
            placeholder="RefreshToken Validate"
            value={
              inputs.emailRefreshTokenValidate
                ? new Date(inputs.emailRefreshTokenValidate).toLocaleString('pt-BR')
                : ''
            }
            name="emailRefreshTokenValidate"
            disabled
            autoComplete="off"
          />
        </Paper>
      </Grid>

      {/* RefreshToken */}
      <Grid item xs={6}>
        <label className={classes.label}>RefreshToken</label>
        <Paper className={classes.medium} elevation={0}>
          <Input
            className={classes.input}
            placeholder="RefreshToken"
            value={inputs.emailRefreshToken}
            name="emailRefreshToken"
            onChange={handleInputChange}
            autoComplete="off"
            disabled
          />
        </Paper>
      </Grid>

    </Grid>
  </AccordionDetails>
</Accordion>


                <Accordion defaultExpanded>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                    className={classes.summary}
                  >
                    <Typography className={classes.heading}>Layouts Emails</Typography>
                  </AccordionSummary>
                  <AccordionDetails className={classes.details}>
                    <Grid container>
                      <Grid item xs={6}>
                        <label className={classes.label}>Layout e-mail Rede</label>
                        <Paper className={classes.medium} elevation={0}>
                          <NativeSelect
                            className={classes.input}
                            value={inputs.layoutEmailAncoraId}
                            name="layoutEmailAncoraId"
                            onChange={handleInputChange}
                            error={getErros.includes('LayoutEmailAncoraId')}
                            onBlur={(event) =>
                              getErros.includes('LayoutEmailAncoraId') &&
                              setErros(
                                getErros.filter(function (item) {
                                  return item !== 'LayoutEmailAncoraId';
                                }),
                              )
                            }
                          >
                            <option value="0">FALTA PREENCHER</option>
                            {getLayoutsEmailsAncoras.map((layoutEmailAncora) => (
                              <option
                                key={layoutEmailAncora.layoutEmailAncoraId}
                                value={layoutEmailAncora.layoutEmailAncoraId}
                              >
                                {layoutEmailAncora.nome}
                              </option>
                            ))}
                          </NativeSelect>
                        </Paper>
                      </Grid>
                      <Grid item xs={6}>
                        <label className={classes.label}>Layout e-mail Fechamento Mês</label>
                        <Paper className={classes.medium} elevation={0}>
                          <NativeSelect
                            className={classes.input}
                            value={inputs.layoutEmailFechamentoMesId}
                            name="layoutEmailFechamentoMesId"
                            onChange={handleInputChange}
                            error={getErros.includes('layoutEmailFechamentoMesId')}
                            onBlur={(event) =>
                              getErros.includes('layoutEmailFechamentoMesId') &&
                              setErros(
                                getErros.filter(function (item) {
                                  return item !== 'layoutEmailFechamentoMesId';
                                }),
                              )
                            }
                          >
                            <option value="0">FALTA PREENCHER</option>
                            {getLayoutsEmailsFechamentosMeses.map(
                              (layoutsEmailsFechamentoMeses) => (
                                <option
                                  key={layoutsEmailsFechamentoMeses.layoutEmailFechamentoMesId}
                                  value={layoutsEmailsFechamentoMeses.layoutEmailFechamentoMesId}
                                >
                                  {layoutsEmailsFechamentoMeses.nome}
                                </option>
                              ),
                            )}
                          </NativeSelect>
                        </Paper>
                      </Grid>
                      <Grid item xs={6}>
                        <label className={classes.label}>Layout e-mail fornecedor</label>
                        <Paper className={classes.medium} elevation={0}>
                          <NativeSelect
                            className={classes.input}
                            value={inputs.layoutEmailFornecedorId}
                            name="layoutEmailFornecedorId"
                            onChange={handleInputChange}
                            error={getErros.includes('LayoutEmailFornecedorId')}
                            onBlur={(event) =>
                              getErros.includes('LayoutEmailFornecedorId') &&
                              setErros(
                                getErros.filter(function (item) {
                                  return item !== 'LayoutEmailFornecedorId';
                                }),
                              )
                            }
                          >
                            <option value="0">FALTA PREENCHER</option>
                            {getLayoutsEmailsAntecipacoes.map((layoutEmailFornecedor) => (
                              <option
                                key={layoutEmailFornecedor.layoutEmailFornecedorId}
                                value={layoutEmailFornecedor.layoutEmailFornecedorId}
                              >
                                {layoutEmailFornecedor.nome}
                              </option>
                            ))}
                          </NativeSelect>
                        </Paper>
                      </Grid>
                      <Grid item xs={6}>
                        <label className={classes.label}>Layout e-mail interesse</label>
                        <Paper className={classes.medium} elevation={0}>
                          <NativeSelect
                            className={classes.input}
                            value={inputs.layoutEmailInteresseId}
                            name="layoutEmailInteresseId"
                            onChange={handleInputChange}
                            error={getErros.includes('LayoutEmailInteresseId')}
                            onBlur={(event) =>
                              getErros.includes('LayoutEmailInteresseId') &&
                              setErros(
                                getErros.filter(function (item) {
                                  return item !== 'LayoutEmailInteresseId';
                                }),
                              )
                            }
                          >
                            <option value="0">FALTA PREENCHER</option>
                            {getLayoutsEmailsInteresses.map((layoutsEmailsInteresses) => (
                              <option
                                key={layoutsEmailsInteresses.layoutEmailInteresseId}
                                value={layoutsEmailsInteresses.layoutEmailInteresseId}
                              >
                                {layoutsEmailsInteresses.nome}
                              </option>
                            ))}
                          </NativeSelect>
                        </Paper>
                      </Grid>
                      <Grid item xs={6}>
                        <label className={classes.label}>Layout e-mail antecipação aprovada</label>
                        <Paper className={classes.medium} elevation={0}>
                          <NativeSelect
                            className={classes.input}
                            value={inputs.layoutEmailAntecipacaoAprovadaId}
                            name="layoutEmailAntecipacaoAprovadaId"
                            onChange={handleInputChange}
                            error={getErros.includes('LayoutEmailAntecipacaoAprovadaId')}
                            onBlur={(event) =>
                              getErros.includes('LayoutEmailAntecipacaoAprovadaId') &&
                              setErros(
                                getErros.filter(function (item) {
                                  return item !== 'LayoutEmailAntecipacaoAprovadaId';
                                }),
                              )
                            }
                          >
                            <option value="0">FALTA PREENCHER</option>
                            {getLayoutsEmailsAntecipacoesAprovadas.map(
                              (layoutEmailAntecipacaoAprovada) => (
                                <option
                                  key={
                                    layoutEmailAntecipacaoAprovada.layoutEmailAntecipacaoAprovadaId
                                  }
                                  value={
                                    layoutEmailAntecipacaoAprovada.layoutEmailAntecipacaoAprovadaId
                                  }
                                >
                                  {layoutEmailAntecipacaoAprovada.nome}
                                </option>
                              ),
                            )}
                          </NativeSelect>
                        </Paper>
                      </Grid>
                      <Grid item xs={6}>
                        <label className={classes.label}>Layout e-mail antecipação reprovada</label>
                        <Paper className={classes.medium} elevation={0}>
                          <NativeSelect
                            className={classes.input}
                            value={inputs.layoutEmailAntecipacaoReprovadaId}
                            name="layoutEmailAntecipacaoReprovadaId"
                            onChange={handleInputChange}
                            error={getErros.includes('LayoutEmailAntecipacaoReprovadaId')}
                            onBlur={(event) =>
                              getErros.includes('LayoutEmailAntecipacaoReprovadaId') &&
                              setErros(
                                getErros.filter(function (item) {
                                  return item !== 'LayoutEmailAntecipacaoReprovadaId';
                                }),
                              )
                            }
                          >
                            <option value="0">FALTA PREENCHER</option>
                            {getLayoutsEmailsAntecipacoesReprovadas.map(
                              (layoutEmailAntecipacaoReprovada) => (
                                <option
                                  key={
                                    layoutEmailAntecipacaoReprovada.layoutEmailAntecipacaoReprovadaId
                                  }
                                  value={
                                    layoutEmailAntecipacaoReprovada.layoutEmailAntecipacaoReprovadaId
                                  }
                                >
                                  {layoutEmailAntecipacaoReprovada.nome}
                                </option>
                              ),
                            )}
                          </NativeSelect>
                        </Paper>
                      </Grid>
                      <Grid item xs={6}>
                        <label className={classes.label}>Layout e-mail antecipação vencida</label>
                        <Paper className={classes.medium} elevation={0}>
                          <NativeSelect
                            className={classes.input}
                            value={inputs.layoutEmailAntecipacaoVencidaId}
                            name="layoutEmailAntecipacaoVencidaId"
                            onChange={handleInputChange}
                            error={getErros.includes('LayoutEmailAntecipacaoVencidaId')}
                            onBlur={(event) =>
                              getErros.includes('LayoutEmailAntecipacaoVencidaId') &&
                              setErros(
                                getErros.filter(function (item) {
                                  return item !== 'LayoutEmailAntecipacaoVencidaId';
                                }),
                              )
                            }
                          >
                            <option value="0">FALTA PREENCHER</option>
                            {getLayoutsEmailsAntecipacoesVencidas.map(
                              (layoutEmailAntecipacaoVencida) => (
                                <option
                                  key={
                                    layoutEmailAntecipacaoVencida.layoutEmailAntecipacaoVencidaId
                                  }
                                  value={
                                    layoutEmailAntecipacaoVencida.layoutEmailAntecipacaoVencidaId
                                  }
                                >
                                  {layoutEmailAntecipacaoVencida.nome}
                                </option>
                              ),
                            )}
                          </NativeSelect>
                        </Paper>
                      </Grid>
                    </Grid>
                  </AccordionDetails>
                </Accordion>
                <Accordion defaultExpanded>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                    className={classes.summary}
                  >
                    <Typography className={classes.heading}>Slip Pagamento</Typography>
                  </AccordionSummary>
                  <AccordionDetails className={classes.details}>
                    <Grid container>
                      <Grid item xs={6}>
                        <label className={classes.label}>Ordem titulos</label>
                        <Paper className={classes.medium} elevation={0}>
                          <NativeSelect
                            className={classes.input}
                            value={inputs.ordemTitulos}
                            name="ordemTitulos"
                            onChange={handleInputChange}
                            error={getErros.includes('enumAncorasOrdemTitulos')}
                            onBlur={(event) =>
                              getErros.includes('enumAncorasOrdemTitulos') &&
                              setErros(
                                getErros.filter(function (item) {
                                  return item !== 'enumAncorasOrdemTitulos';
                                }),
                              )
                            }
                          >
                            <option selected value="NumeroNotaFiscal">
                              Número nota fiscal
                            </option>
                            <option value="Loja">Loja</option>
                            <option value="Sequencia">Sequencia</option>
                            <option value="DataVencimento">Data Vencimento</option>
                          </NativeSelect>
                        </Paper>
                      </Grid>
                      <Grid item xs={6}>
                        <label className={classes.label}>Condição</label>
                        <Paper className={classes.medium} elevation={0}>
                          <NativeSelect
                            className={classes.input}
                            value={inputs.condicao}
                            name="condicao"
                            onChange={handleInputChange}
                            error={getErros.includes('Condicao')}
                            onBlur={(event) =>
                              getErros.includes('Condicao') &&
                              setErros(
                                getErros.filter(function (item) {
                                  return item !== 'Condicao';
                                }),
                              )
                            }
                          >
                            <option selected value="Nenhum">
                              Nenhum{' '}
                            </option>
                            <option value="Taxa">Taxa </option>
                            <option value="Desagio">Desagio </option>
                            <option value="Ambos">Ambos </option>
                          </NativeSelect>
                        </Paper>
                      </Grid>
                      <Grid item xs={6}>
                        <label className={classes.label}>Controle conta bancaria</label>
                        <Paper className={classes.medium} elevation={0}>
                          <NativeSelect
                            className={classes.input}
                            value={inputs.controlaContaBancaria}
                            name="controlaContaBancaria"
                            onChange={handleInputChange}
                            error={getErros.includes('ControlaContaBancaria')}
                            onBlur={(event) =>
                              getErros.includes('ControlaContaBancaria') &&
                              setErros(
                                getErros.filter(function (item) {
                                  return item !== 'ControlaContaBancaria';
                                }),
                              )
                            }
                          >
                            <option selected value="Nao">
                              Não
                            </option>
                            <option value="Sim">Sim</option>
                          </NativeSelect>
                        </Paper>
                      </Grid>
                      <Grid item xs={6}>
                        <label className={classes.label}>E-mail ancora agrupado</label>
                        <Paper className={classes.medium} elevation={0}>
                          <NativeSelect
                            className={classes.input}
                            value={inputs.emailAncoraAgrupado}
                            name="emailAncoraAgrupado"
                            onChange={handleInputChange}
                            error={getErros.includes('EmailAncoraAgrupado')}
                            onBlur={(event) =>
                              getErros.includes('EmailAncoraAgrupado') &&
                              setErros(
                                getErros.filter(function (item) {
                                  return item !== 'EmailAncoraAgrupado';
                                }),
                              )
                            }
                          >
                            <option selected value="Nao">
                              Não
                            </option>
                            <option value="Sim">Sim</option>
                          </NativeSelect>
                        </Paper>
                      </Grid>
                      <Grid item xs={6}>
                        <label className={classes.label}>Segregado por loja</label>
                        <Paper className={classes.medium} elevation={0}>
                          <NativeSelect
                            className={classes.input}
                            value={inputs.segregadoPorLoja}
                            name="segregadoPorLoja"
                            onChange={handleInputChange}
                            error={getErros.includes('SegregadoPorLoja')}
                            onBlur={(event) =>
                              getErros.includes('SegregadoPorLoja') &&
                              setErros(
                                getErros.filter(function (item) {
                                  return item !== 'SegregadoPorLoja';
                                }),
                              )
                            }
                          >
                            <option selected value="Nao">
                              Não
                            </option>
                            <option value="Sim">Sim</option>
                          </NativeSelect>
                        </Paper>
                      </Grid>
                      <Grid item xs={6}>
                        <label className={classes.label}>
                          Usar razao com o codigo interno do fornecedor
                        </label>
                        <Paper className={classes.medium} elevation={0}>
                          <NativeSelect
                            className={classes.input}
                            value={inputs.usarRazaoComCodigoInternoFornecedor}
                            name="usarRazaoComCodigoInternoFornecedor"
                            onChange={handleInputChange}
                            error={getErros.includes('UsarRazaoComCodigoInternoFornecedor')}
                            onBlur={(event) =>
                              getErros.includes('UsarRazaoComCodigoInternoFornecedor') &&
                              setErros(
                                getErros.filter(function (item) {
                                  return item !== 'UsarRazaoComCodigoInternoFornecedor';
                                }),
                              )
                            }
                          >
                            <option selected value="Nao">
                              Não
                            </option>
                            <option value="Sim">Sim</option>
                          </NativeSelect>
                        </Paper>
                      </Grid>
                    </Grid>
                  </AccordionDetails>
                </Accordion>

                <Accordion defaultExpanded>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                    className={classes.summary}
                  >
                    <Typography className={classes.heading}>Endereço</Typography>
                  </AccordionSummary>
                  <AccordionDetails className={classes.details}>
                    <Grid container>
                      <Grid item xs={6}>
                        <label className={classes.label}>Cep</label>
                        <Paper className={classes.medium} elevation={0}>
                          <InputMask
                            mask="99.999-999"
                            value={inputs.cep}
                            name="cep"
                            disabled={false}
                            onChange={handleInputChange}
                            onBlur={(event) => {
                              if (getErros.includes('Cep')) {
                                setErros(
                                  getErros.filter(function (item) {
                                    return item !== 'Cep';
                                  }),
                                );
                              }
                              findCep(inputs.cep);
                            }}
                          >
                            {() => (
                              <Input
                                className={classes.input}
                                placeholder="CEP"
                                name="cep"
                                inputProps={{
                                  autocomplete: 'off',
                                }}
                                error={getErros.includes('Cep')}
                              />
                            )}
                          </InputMask>
                        </Paper>
                      </Grid>
                      <Grid item xs={6}>
                        <label className={classes.label}>Logradouro</label>
                        <Paper className={classes.medium} elevation={0}>
                          <Input
                            className={classes.input}
                            classes={{ input: classes.inputText }}
                            placeholder="Logradouro"
                            name="logradouro"
                            readOnly={inputsBlocked.includes('logradouro')}
                            autocomplete="off"
                            inputProps={{
                              maxLength: 100,
                            }}
                            onBlur={(event) =>
                              getErros.includes('Logradouro') &&
                              setErros(
                                getErros.filter(function (item) {
                                  return item !== 'Logradouro';
                                }),
                              )
                            }
                            error={getErros.includes('Logradouro')}
                            value={inputs.logradouro}
                            onChange={handleInputChange}
                          />
                        </Paper>
                      </Grid>
                      <Grid item xs={6}>
                        <label className={classes.label}>Bairro</label>
                        <Paper className={classes.medium} elevation={0}>
                          <Input
                            className={classes.input}
                            classes={{ input: classes.inputText }}
                            placeholder="Bairro"
                            name="bairro"
                            readOnly={inputsBlocked.includes('bairro')}
                            autocomplete="off"
                            onBlur={(event) =>
                              getErros.includes('Bairro') &&
                              setErros(
                                getErros.filter(function (item) {
                                  return item !== 'Bairro';
                                }),
                              )
                            }
                            error={getErros.includes('Bairro')}
                            value={inputs.bairro}
                            inputProps={{
                              maxLength: 50,
                            }}
                            onChange={handleInputChange}
                          />
                        </Paper>
                      </Grid>

                      <Grid item xs={6}>
                        <label className={classes.label}>Estado</label>
                        <Paper className={classes.medium} elevation={0}>
                          <NativeSelect
                            className={classes.input}
                            value={inputs.estadoId}
                            name="estadoId"
                            disabled={inputsBlocked.includes('estado')}
                            onChange={handleInputChange}
                            error={getErros.includes('EstadoId')}
                            onBlur={(event) =>
                              getErros.includes('EstadoId') &&
                              setErros(
                                getErros.filter(function (item) {
                                  return item !== 'EstadoId';
                                }),
                              )
                            }
                          >
                            <option value="0">Selecione o estado</option>
                            {getEstados.map((estado) => (
                              <option key={estado.estadoId} value={estado.estadoId}>
                                {estado.estado}
                              </option>
                            ))}
                          </NativeSelect>
                        </Paper>
                      </Grid>
                      <Grid item xs={1}>
                        <label className={classes.label}>Número</label>
                        <Paper className={classes.small} elevation={0}>
                          <Input
                            type="text"
                            className={classes.input}
                            placeholder="Número"
                            name="numero"
                            autocomplete="off"
                            onBlur={(event) =>
                              getErros.includes('Numero') &&
                              setErros(
                                getErros.filter(function (item) {
                                  return item !== 'Numero';
                                }),
                              )
                            }
                            error={getErros.includes('Numero')}
                            inputProps={{
                              maxLength: 6,
                            }}
                            value={inputs.numero}
                            onChange={(event) => {
                              if (event.target.value !== '') {
                                if (/^[0-9\b]+$/.test(event.target.value)) {
                                  handleInputChange(event);
                                }
                              } else {
                                handleInputChange(event);
                              }
                            }}
                          />
                        </Paper>
                      </Grid>
                      <Grid item xs={5}>
                        <label className={classes.label}>Complemento</label>
                        <Paper className={classes.medium} elevation={0}>
                          <Input
                            className={classes.input}
                            classes={{ input: classes.inputText }}
                            placeholder="Complemento"
                            name="complemento"
                            autocomplete="off"
                            onBlur={(event) =>
                              getErros.includes('Complemento') &&
                              setErros(
                                getErros.filter(function (item) {
                                  return item !== 'Complemento';
                                }),
                              )
                            }
                            error={getErros.includes('Complemento')}
                            inputProps={{
                              maxLength: 50,
                            }}
                            value={inputs.complemento}
                            onChange={handleInputChange}
                          />
                        </Paper>
                      </Grid>
                      <Grid item xs={6}>
                        <label className={classes.label}>Município</label>
                        <Paper className={classes.medium} elevation={0}>
                          <NativeSelect
                            className={classes.input}
                            value={inputs.municipioId}
                            name="municipioId"
                            onChange={handleInputChange}
                            error={getErros.includes('MunicipioId')}
                            onBlur={(event) =>
                              getErros.includes('MunicipioId') &&
                              setErros(
                                getErros.filter(function (item) {
                                  return item !== 'MunicipioId';
                                }),
                              )
                            }
                            disabled={inputsBlocked.includes('municipio')}
                          >
                            <option value="0">Selecione o município</option>
                            {getMunicipios.map((municipio) => (
                              <option key={municipio.municipioId} value={municipio.municipioId}>
                                {municipio.municipio}
                              </option>
                            ))}
                          </NativeSelect>
                        </Paper>
                      </Grid>
                    </Grid>
                  </AccordionDetails>
                </Accordion>
                <Accordion defaultExpanded>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                    className={classes.summary}
                  >
                    <Typography className={classes.heading}>Horarios para aprovação de propostas</Typography>
                  </AccordionSummary>
                  <AccordionDetails className={classes.details} style={{ flexDirection: 'column' }}>
                    <Grid container>
                      <Grid item xs={6}>
                        <label className={classes.label}>Aprovação após horario limite</label>
                        <Paper className={classes.medium} elevation={0}>
                          <NativeSelect
                            className={classes.input}
                            value={inputs.aprovacaoAposHoraLimite}
                            name="aprovacaoAposHoraLimite"
                            onChange={handleInputChange}
                            error={getErros.includes('AprovacaoAposHoraLimite')}
                            onBlur={(event) =>
                              getErros.includes('AprovacaoAposHoraLimite') &&
                              setErros(
                                getErros.filter(function (item) {
                                  return item !== 'AprovacaoAposHoraLimite';
                                }),
                              )
                            }
                            disabled={inputsBlocked.includes('AprovacaoAposHoraLimite')}
                          >
                            <option selected value="NaoPermitido">
                              Não permitido
                            </option>
                            <option value="Permitido">Permitido</option>
                            <option value="PermitidoComAutorizacao">Permitido com autorização</option>
                          </NativeSelect>
                        </Paper>
                      </Grid>
                    </Grid>
                    <Grid container>
                      <Grid item xs={2}>
                        <label className={classes.label}>Horario Limite - Segunda</label>
                        <Paper className={classes.small} elevation={0}>
                          <InputMask
                            mask="99:99"
                            value={inputs.horaLimiteAceitePropostaSegunda}
                            name="horaLimiteAceitePropostaSegunda"
                            onBlur={(event) =>
                              getErros.includes('HoraLimiteAceitePropostaSegunda') &&
                              setErros(
                                getErros.filter(function (item) {
                                  return item !== 'HoraLimiteAceitePropostaSegunda';
                                }),
                              )
                            }
                            disabled={false}
                            onChange={(event) => { handleTimeValues(event, event.target.value) }}
                            autoComplete="off"
                            tabIndex={0}
                            onFocus={(e) => { e.target.setSelectionRange(0, 0); }}
                          >
                            {() => (
                              <Input
                                className={classes.input}
                                placeholder="00:00"
                                name="horaLimiteAceitePropostaSegunda"
                                error={getErros.includes('HoraLimiteAceitePropostaSegunda')}
                              />
                            )}
                          </InputMask>
                        </Paper>
                      </Grid>
                      <Grid item xs={2}>
                        <label className={classes.label}>Horario Limite - Terça</label>
                        <Paper className={classes.small} elevation={0}>
                          <InputMask
                            mask="99:99"
                            value={inputs.horaLimiteAceitePropostaTerca}
                            name="horaLimiteAceitePropostaTerca"
                            onBlur={(event) =>
                              getErros.includes('HoraLimiteAceitePropostaTerca') &&
                              setErros(
                                getErros.filter(function (item) {
                                  return item !== 'HoraLimiteAceitePropostaTerca';
                                }),
                              )
                            }
                            disabled={false}
                            onChange={(event) => { handleTimeValues(event, event.target.value) }}
                            autoComplete="off"
                            tabIndex={0}
                            onFocus={(e) => { e.target.setSelectionRange(0, 0); }}
                          >
                            {() => (
                              <Input
                                className={classes.input}
                                placeholder="00:00"
                                name="horaLimiteAceitePropostaTerca"
                                error={getErros.includes('HoraLimiteAceitePropostaTerca')}
                              />
                            )}
                          </InputMask>
                        </Paper>
                      </Grid>
                      <Grid item xs={2}>
                        <label className={classes.label}>Horario Limite - Quarta</label>
                        <Paper className={classes.small} elevation={0}>
                          <InputMask
                            mask="99:99"
                            value={inputs.horaLimiteAceitePropostaQuarta}
                            name="horaLimiteAceitePropostaQuarta"
                            onBlur={(event) =>
                              getErros.includes('HoraLimiteAceitePropostaQuarta') &&
                              setErros(
                                getErros.filter(function (item) {
                                  return item !== 'HoraLimiteAceitePropostaQuarta';
                                }),
                              )
                            }
                            disabled={false}
                            onChange={(event) => { handleTimeValues(event, event.target.value) }}
                            autoComplete="off"
                            tabIndex={0}
                            onFocus={(e) => { e.target.setSelectionRange(0, 0); }}
                          >
                            {() => (
                              <Input
                                className={classes.input}
                                placeholder="00:00"
                                name="horaLimiteAceitePropostaQuarta"
                                error={getErros.includes('HoraLimiteAceitePropostaQuarta')}
                              />
                            )}
                          </InputMask>
                        </Paper>
                      </Grid>
                      <Grid item xs={2}>
                        <label className={classes.label}>Horario Limite - Quinta</label>
                        <Paper className={classes.small} elevation={0}>
                          <InputMask
                            mask="99:99"
                            value={inputs.horaLimiteAceitePropostaQuinta}
                            name="horaLimiteAceitePropostaQuinta"
                            onBlur={(event) =>
                              getErros.includes('HoraLimiteAceitePropostaQuinta') &&
                              setErros(
                                getErros.filter(function (item) {
                                  return item !== 'HoraLimiteAceitePropostaQuinta';
                                }),
                              )
                            }
                            disabled={false}
                            onChange={(event) => { handleTimeValues(event, event.target.value) }}
                            autoComplete="off"
                            tabIndex={0}
                            onFocus={(e) => { e.target.setSelectionRange(0, 0); }}
                          >
                            {() => (
                              <Input
                                className={classes.input}
                                placeholder="00:00"
                                name="horaLimiteAceitePropostaQuinta"
                                error={getErros.includes('HoraLimiteAceitePropostaQuinta')}
                              />
                            )}
                          </InputMask>
                        </Paper>
                      </Grid>
                      <Grid item xs={2}>
                        <label className={classes.label}>Horario Limite - Sexta</label>
                        <Paper className={classes.small} elevation={0}>
                          <InputMask
                            mask="99:99"
                            value={inputs.horaLimiteAceitePropostaSexta}
                            name="horaLimiteAceitePropostaSexta"
                            onBlur={(event) =>
                              getErros.includes('HoraLimiteAceitePropostaSexta') &&
                              setErros(
                                getErros.filter(function (item) {
                                  return item !== 'HoraLimiteAceitePropostaSexta';
                                }),
                              )
                            }
                            disabled={false}
                            onChange={(event) => { handleTimeValues(event, event.target.value) }}
                            autoComplete="off"
                            tabIndex={0}
                            onFocus={(e) => { e.target.setSelectionRange(0, 0); }}
                          >
                            {() => (
                              <Input
                                className={classes.input}
                                placeholder="00:00"
                                name="horaLimiteAceitePropostaSexta"
                                error={getErros.includes('HoraLimiteAceitePropostaSexta')}
                              />
                            )}
                          </InputMask>
                        </Paper>
                      </Grid>
                    </Grid>
                  </AccordionDetails>
                </Accordion>

                <Accordion defaultExpanded>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                    className={classes.summary}
                  >
                    <Typography className={classes.heading}>Configurações</Typography>
                  </AccordionSummary>
                  <AccordionDetails className={classes.details}>
                    <Grid container>
                      <Grid item xs={6}>
                        <label className={classes.label}>Ambiente</label>
                        <Paper className={classes.medium} elevation={0}>
                          <NativeSelect
                            className={classes.input}
                            value={inputs.ambiente}
                            name="ambiente"
                            onChange={handleInputChange}
                            error={getErros.includes('Ambiente')}
                            onBlur={(event) =>
                              getErros.includes('Ambiente') &&
                              setErros(
                                getErros.filter(function (item) {
                                  return item !== 'Ambiente';
                                }),
                              )
                            }
                            disabled={inputsBlocked.includes('Ambiente')}
                          >
                            <option value="Desenvolvimento">Desenvolvimento</option>
                            <option value="Producao">Produção</option>
                          </NativeSelect>
                        </Paper>
                      </Grid>
                      <Grid item xs={6}></Grid>
                    </Grid>
                  </AccordionDetails>
                </Accordion>

                <Accordion defaultExpanded>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                    className={classes.summary}
                  >
                    <Typography className={classes.heading}>Logotipo</Typography>
                  </AccordionSummary>
                  <AccordionDetails className={classes.details}>
                    <Grid container>
                      {inputs.newLogotipoImagemBase64 ? (
                        <div className={classes.divLogo}>
                          <img
                            src={inputs.newLogotipoImagemBase64}
                            onError={() => setLogoLoaded(true)}
                            onLoad={() => setLogoLoaded(true)}
                          />
                        </div>
                      ) : inputs.logotipoImagemBase64 ? (
                        <div className={classes.divLogo}>
                          <img
                            src={`${inputs.logotipoImagemBase64
                              }?date=${new Date().toLocaleString()}`}
                            onError={() => setLogoLoaded(true)}
                            onLoad={() => setLogoLoaded(true)}
                          />
                        </div>
                      ) : (
                        <></>
                      )}

                      <label className={classes.label}>Arquivo de Logotipo</label>
                      <Paper className={classes.medium} elevation={0} style={{ width: '100%' }}>
                        <Input
                          style={{ textTransform: 'uppercase !important' }}
                          className={classes.input}
                          classes={{ input: classes.inputText }}
                          placeholder="Logotipo"
                          type="file"
                          name="newLogotipoImagemBase64"
                          onBlur={(event) =>
                            getErros.includes('Logotipo') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'Logotipo';
                              }),
                            )
                          }
                          disabled={!getLogoLoaded}
                          error={getErros.includes('Logotipo')}
                          onChange={(event) => {
                            setLogoLoaded(false);
                            handleFileChange(event);
                          }}
                          inputProps={{
                            accept: '.jpeg, .png, .jpg',
                          }}
                          autoComplete="off"
                        />
                      </Paper>
                    </Grid>
                  </AccordionDetails>
                </Accordion>

                <Accordion defaultExpanded>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                    className={classes.summary}
                  >
                    <Typography className={classes.heading}>
                      Arquivo de e-mail de assinatura
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails className={classes.details}>
                    <Grid container>
                      {inputs.newEmailAssinaturaBase64 ? (
                        <div className={classes.divLogo}>
                          <img
                            src={inputs.newEmailAssinaturaBase64}
                            onError={() => setLogoLoaded(true)}
                            onLoad={() => setAssinaturaLoaded(true)}
                          />
                        </div>
                      ) : inputs.emailAssinaturaBase64 ? (
                        <div className={classes.divLogo}>
                          <img
                            src={`${inputs.emailAssinaturaBase64
                              }?date=${new Date().toLocaleString()}`}
                            onError={() => setLogoLoaded(true)}
                            onLoad={() => setAssinaturaLoaded(true)}
                          />
                        </div>
                      ) : (
                        <></>
                      )}

                      <label className={classes.label}>Arquivo de e-mail de assinatura</label>
                      <Paper className={classes.medium} elevation={0} style={{ width: '100%' }}>
                        <Input
                          style={{ textTransform: 'uppercase !important' }}
                          className={classes.input}
                          classes={{ input: classes.inputText }}
                          placeholder="Arquivo de e-mail de assinatura"
                          name="newEmailAssinaturaBase64"
                          type="file"
                          onBlur={(event) =>
                            getErros.includes('EmailAssinatura') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'EmailAssinatura';
                              }),
                            )
                          }
                          disabled={!getAssinaturaLoaded}
                          error={getErros.includes('EmailAssinatura')}
                          onChange={(event) => {
                            setAssinaturaLoaded(false);
                            handleFileChange(event);
                          }}
                          autoComplete="off"
                          inputProps={{
                            accept: '.jpeg, .png, .jpg',
                          }}
                        />
                      </Paper>
                    </Grid>
                  </AccordionDetails>
                </Accordion>

                <Accordion defaultExpanded>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                    className={classes.summary}
                  >
                    <Typography className={classes.heading}>Dados do Registro</Typography>
                  </AccordionSummary>
                  <AccordionDetails className={classes.details}>
                    <Grid container>
                      <Grid item xs={6}>
                        <label className={classes.label}>Data de Registro</label>
                        <Paper className={classes.medium} elevation={0}>
                          <Input
                            className={classes.input}
                            value={
                              inputs.dataRegistro && formatDateTimeToRender(inputs.dataRegistro)
                            }
                            placeholder="Data do Registro"
                          />
                        </Paper>
                      </Grid>

                      <Grid item xs={6}>
                        <label className={classes.label}>Data da Atualização</label>
                        <Paper className={classes.medium} elevation={0}>
                          <Input
                            className={classes.input}
                            value={
                              inputs.dataAtualizacao
                                ? formatDateTimeToRender(inputs.dataAtualizacao)
                                : ''
                            }
                            placeholder="Data da Atualização"
                          />
                        </Paper>
                      </Grid>
                    </Grid>
                  </AccordionDetails>
                </Accordion>
                <div className={classes.divButton}>
                  <Button variant="contained" type="submit" className={classes.button}>
                    Atualizar
                  </Button>
                </div>
              </form>

              <Accordion
                onChange={(event, expanded) => {
                  if (!expanded) {
                    dispatch(CreatorsAnchors.changeModal({ anchor: 'ancoras-contatos' }));
                    dispatch(
                      CreatorsAnchors.changeFilter({ anchor: 'ancoras-contatos', filter: null }),
                    );
                  }
                  if (expanded && !getAncorasContatos.length) {
                    findAllAncorasContatos();
                  }
                }}
                ref={ancorasContatosRef}
                defaultExpanded={lastGrid === 'ancoras-contatos'}
                className={classes.accordionRoot}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="ancoras-contatos"
                  className={classes.summary}
                >
                  <Typography className={classes.heading}>Contatos</Typography>
                </AccordionSummary>
                <AccordionDetails className={classes.details}>
                  <Grid container>
                    {getAncorasLoadingContatos ? (
                      <Loading />
                    ) : (
                      <GridAncorasContatos
                        ancoraId={ancoraId}
                        ancoraName={inputs.nomeFantasia}
                        findAllAncorasContatos={findAllAncorasContatos}
                        getAncorasContatos={getAncorasContatos}
                      />
                    )}
                  </Grid>
                </AccordionDetails>
              </Accordion>

              <Accordion className={classes.accordionRoot}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel-ancoras-importacoes-titulos"
                  id="ancoras-importacoes-titulos"
                  className={classes.summary}
                >
                  <Typography className={classes.heading}>Integrações de Importação</Typography>
                </AccordionSummary>
                <AccordionDetails className={classes.details}>
                  <Grid container>
                    <GridAncorasImportacoesTitulos ancoraId={ancoraId} />
                    <Grid item xs={12} style={{ marginTop: 12, textAlign: 'right' }}>
                      {/* Atalho para a tela de execucoes da integracao Bluesoft. */}
                      <a
                        href={`/app/importacoes-titulos-execucoes?ancoraId=${ancoraId}`}
                        style={{
                          color: '#026894',
                          textDecoration: 'underline',
                          fontWeight: 'bold',
                          fontSize: '13px',
                          cursor: 'pointer',
                        }}
                      >
                        Ver Execuções
                      </a>
                      <a
                        href="/app/erps-controles-baixas-titulos-antecipados"
                        style={{
                          color: '#026894',
                          textDecoration: 'underline',
                          fontWeight: 'bold',
                          fontSize: '13px',
                          cursor: 'pointer',
                          marginLeft: 16,
                        }}
                      >
                        Ver Baixas de Títulos
                      </a>
                    </Grid>
                  </Grid>
                </AccordionDetails>
              </Accordion>

              <Accordion
                onChange={(event, expanded) => {
                  if (!expanded) {
                    dispatch(CreatorsAnchors.changeModal({ anchor: 'ancoras-taxas-faixas' }));
                    dispatch(
                      CreatorsAnchors.changeFilter({
                        anchor: 'ancoras-taxas-faixas',
                        filter: null,
                      }),
                    );
                  }

                  if (expanded && !getAncorasTaxasFaixas.length) {
                    findAllAncorasTaxasFaixas();
                  }
                }}
                defaultExpanded={lastGrid === 'ancoras-taxas-faixas'}
                className={classes.accordionRoot}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                  ref={ancorasTaxasFaixasRef}
                  className={classes.summary}
                >
                  <Typography className={classes.heading}>Taxas faixas</Typography>
                </AccordionSummary>
                <AccordionDetails className={classes.details}>
                  <Grid container>
                    {getAncorasLoadingTaxasFaixas ? (
                      <Loading />
                    ) : (
                      <GridAncorasTaxasFaixas
                        ancoraId={ancoraId}
                        ancoraName={inputs.nomeFantasia}
                        findAllAncorasTaxasFaixas={findAllAncorasTaxasFaixas}
                        getAncorasTaxasFaixas={getAncorasTaxasFaixas}
                      />
                    )}
                  </Grid>
                </AccordionDetails>
              </Accordion>

              <Accordion
                onChange={(event, expanded) => {
                  if (!expanded) {
                    dispatch(CreatorsAnchors.changeModal({ anchor: 'ancoras-lojas' }));
                    dispatch(
                      CreatorsAnchors.changeFilter({ anchor: 'ancoras-lojas', filter: null }),
                    );
                  }
                  if (expanded && !getAncorasLojas.length) {
                    findAllAncorasLojas();
                  }
                }}
                defaultExpanded={lastGrid === 'ancoras-lojas'}
                className={classes.accordionRoot}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                  ref={ancorasLojasRef}
                  className={classes.summary}
                >
                  <Typography className={classes.heading}>Lojas</Typography>
                </AccordionSummary>
                <AccordionDetails className={classes.details}>
                  <Grid container>
                    {getAncorasLoadingLojas ? (
                      <Loading />
                    ) : (
                      <GridAncorasLojas
                        ancoraId={ancoraId}
                        ancoraName={inputs.nomeFantasia}
                        findAllAncorasLojas={findAllAncorasLojas}
                        getAncorasLojas={getAncorasLojas}
                      />
                    )}
                  </Grid>
                </AccordionDetails>
              </Accordion>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default Render;
